export default {
	pollInterval: 2000,
	longPollInterval: 10000,
	aws: {
		region: 'eu-west-3',
		s3: {
			buckets: {
				musicOptimized: 'spectre.staging.music.optimized',
				artworks: 'spectre.staging.artworks',
				artworksOptimized: 'spectre.staging.artworks.optimized',
				userAssets: 'spectre.staging.user-assets',
				messages: 'spectre.staging.messages.originals',
				messagesOptimized: 'spectre.staging.messages.optimized'
			},
			baseUrl: 'https://s3-eu-west-3.amazonaws.com/'
		}
	},
	cdn: {
		paths: {
			music: 'music.originals/',
			musicOptimized: 'music.optimized/',
			assets: 'app-assets/',
			artworks: 'artworks/',
			artworksOptimized: 'artworks.optimized/',
			userAssets: 'user-assets/',
			messages: 'messages.originals/',
			messagesOptimized: 'messages.optimized/'
		},
		baseUrl: 'https://cdn.staging.spectre-music.com/'
	},
	support: {
		url: 'https://support.spectre-music.com'
	},
	sonos: {
		baseUrl: 'https://api.sonos.com/',
		clientId: '939971c1-3ba5-4b69-badc-8f413183f095'
	},
	vauxhall: {
		baseUrl: 'https://vauxhall.staging.spectre-music.com/'
	}
}
